import React, { useState } from 'react';
import { Survey, Model } from 'survey-react-ui';
import 'survey-core/defaultV2.min.css';
import './SurveyForm.css'; // assuming your CSS file is named SurveyForm.css


function SurveyForm() {

  const [isSubmitted, setIsSubmitted] = useState(false); // state to track submission status

// Get the query parameters from the URL
const urlParams = new URLSearchParams(window.location.search);

// Extract the 'trackingid' parameter, or set it to an empty string if it doesn't exist
const trackingId = urlParams.get('trackingid') || '';

console.log("Tracking ID=" + trackingId);

  const surveyJson = {
    title: null,
    showProgressBar: null,
    completedHtml:`<div id="Panel1">
	
            <div class="field-wrapper full-width">
                <span id="Label3"></span>
            </div>

            <div class="centered">
                <img src="Sucessfully_Completed.png">
            </div>

            <div class="centered">
                <span id="Label1" style="font-size:X-Large;">Thank you for your enquiry.</span>
            </div>

            <div class="centered">
                   <span id="Label4">One of our hospitality team will contact you shortly.</span>
            </div>

            <div class="centered">
                <span id="Label2">Chelsea Football Club</span>
            </div>

        
</div>`,
    pages: [
      {
        elements: [
          {
            type: "panel",
            name: "leftPanel",
            elements: [
              { type: "dropdown", name: "title", title: "Title", choices: ["Mr.", "Miss", "Mrs","Ms", "Dr","Prof","Other"], isRequired: true },
              { type: "text", name: "firstName", title: "First Name", isRequired: true },
              { type: "text", name: "lastName", title: "Last Name", isRequired: true },
              { type: "text", name: "phone", title: "Phone Number", inputType: "tel", isRequired: true },
              { type: "text", name: "email", title: "Email", inputType: "text", isRequired: true },
              
            ],
          },
          {
            type: "panel",
            name: "rightPanel",
            elements: [
                { type: "text", name: "dob", title: "Date of Birth", inputType: "date", isRequired: true },
                { type: "comment", name: "address", title: "Address", inputType: "text", isRequired: true, rows: 3},
                { type: "text", name: "city", title: "City", inputType: "text", isRequired: true },
                { type: "text", name: "postcode", title: "Postcode", inputType: "text", isRequired: true },
                
                {
                    "type": "dropdown",
                    "name": "country",
                    "title": "Country",
                    "isRequired": true,
                    "choices": [
                        "Afghanistan", "Albania", "Algeria", "American Samoa", "Andorra",
                        "Angola", "Anguilla", "Antarctica", "Antigua and Barbuda", "Argentina",
                        "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas",
                        "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium",
                        "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia",
                        "Bosnia and Herzegovina", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Territory",
                        "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia",
                        "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central African Republic",
                        "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands",
                        "Colombia", "Comoros", "Congo", "Congo (Democratic Republic)", "Cook Islands",
                        "Costa Rica", "Croatia", "Cuba", "Cyprus", "Czech Republic",
                        "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador",
                        "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia",
                        "Eswatini", "Ethiopia", "Falkland Islands", "Faroe Islands", "Fiji",
                        "Finland", "France", "Gabon", "Gambia", "Georgia",
                        "Germany", "Ghana", "Gibraltar", "Greece", "Greenland",
                        "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey",
                        "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard Island and McDonald Islands",
                        "Honduras", "Hong Kong", "Hungary", "Iceland", "India",
                        "Indonesia", "Iran", "Iraq", "Ireland", "Isle of Man",
                        "Israel", "Italy", "Jamaica", "Japan", "Jersey",
                        "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea (North)",
                        "Korea (South)", "Kuwait", "Kyrgyzstan", "Laos", "Latvia",
                        "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein",
                        "Lithuania", "Luxembourg", "Macao", "Madagascar", "Malawi",
                        "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands",
                        "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico",
                        "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro",
                        "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia",
                        "Nauru", "Nepal", "Netherlands", "New Caledonia", "New Zealand",
                        "Nicaragua", "Niger", "Nigeria", "Niue", "Norfolk Island",
                        "North Macedonia", "Northern Mariana Islands", "Norway", "Oman", "Pakistan",
                        "Palau", "Palestinian Territories", "Panama", "Papua New Guinea", "Paraguay",
                        "Peru", "Philippines", "Pitcairn Islands", "Poland", "Portugal",
                        "Puerto Rico", "Qatar", "Romania", "Russia", "Rwanda",
                        "R�union", "Saint Barth�lemy", "Saint Helena", "Saint Kitts and Nevis", "Saint Lucia",
                        "Saint Martin", "Saint Pierre and Miquelon", "Saint Vincent and the Grenadines", "Samoa", "San Marino",
                        "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles",
                        "Sierra Leone", "Singapore", "Sint Eustatius", "Sint Maarten", "Slovakia",
                        "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia and the South Sandwich Islands",
                        "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname",
                        "Svalbard and Jan Mayen", "Sweden", "Switzerland", "Syria", "Taiwan",
                        "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo",
                        "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey",
                        "Turkmenistan", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates",
                        "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Vanuatu",
                        "Vatican City", "Venezuela", "Vietnam", "Wallis and Futuna", "Western Sahara",
                        "Yemen", "Zambia", "Zimbabwe", "Other"
                    ]
                }

            ],
            startWithNewLine: false, // Place this panel next to the leftPanel
              },


              {
                  type: "panel",
                  name: "queryPanel",
                  elements: [
                      {
                          "type": "comment",
                          "name": "query",
                          "title": "Please provide any other relevant information.",
                          "isRequired": true,
                          "rows": 10
                      },
                  ],
              },

          
          {
            type: "html",
            name: "marketingIntro",
            html: `At Chelsea FC plc and our group companies we would like your permission to keep you up to date with relevant news, offers and promotions from the club and on behalf of our official <a href="https://www.chelseafc.com/en/club-partners" target="_blank" style="color: #001489; text-decoration: underline;">sponsors and partners</a>.`,
          },
          {
            type: "panel",
            name: "marketingPreferencesPanel",
            elements: [
              {
                type: "checkbox",
                name: "marketingPreferences",
                title: "Yes please keep me informed by...",
                choices: ["Email", "Post", "Phone", "SMS"],
                defaultValue: ["Email", "Post", "Phone", "SMS"],  // Pre-check all options


              },
            ],
          },
          {
            type: "html",
            name: "privacyPolicyText",
            html: `We ensure that your personal information is kept secure and safe, and we do not share it with outside companies.<br><br>Please read our <a href="https://www.chelseafc.com/en/privacy-policy" target="_blank" style="color: #001489; text-decoration: underline;">Privacy Policy</a> to learn more about Chelsea FC and its group companies, how we use your information and how to update your preferences for receiving marketing communications from us.*`,
          },
        ],
      },
    ],
    };


    const countryMapping = {
        "UNITED KINGDOM": 255340000,
        "UNITED STATES": 255340225,
        "AFGHANISTAN": 255340001,
        "ALBANIA": 255340002,
        "ALGERIA": 255340003,
        "AMERICAN SAMOA": 255340004,
        "ANDORRA": 255340005,
        "ANGOLA": 255340006,
        "ANGUILLA": 255340007,
        "ANTARCTICA": 255340008,
        "ANTIGUA AND BARBUDA": 255340009,
        "ARGENTINA": 255340010,
        "ARMENIA": 255340011,
        "ARUBA": 255340012,
        "AUSTRALIA": 255340013,
        "AUSTRIA": 255340014,
        "AZERBAIJAN": 255340015,
        "BAHAMAS": 255340016,
        "BAHRAIN": 255340017,
        "BANGLADESH": 255340018,
        "BARBADOS": 255340019,
        "BELARUS": 255340020,
        "BELGIUM": 255340021,
        "BELIZE": 255340022,
        "BENIN": 255340023,
        "BERMUDA": 255340024,
        "BHUTAN": 255340025,
        "BOLIVIA": 255340026,
        "BOSNIA AND HERZEGOWINA": 255340027,
        "BOTSWANA": 255340028,
        "BOUVET ISLAND": 255340029,
        "BRAZIL": 255340030,
        "BRITISH INDIAN OCEAN TERRITORY": 255340031,
        "BRITISH VIRGIN ISLANDS": 255340032,
        "BRUNEI DARUSSALAM": 255340033,
        "BULGARIA": 255340034,
        "BURKINA FASO": 255340035,
        "BURUNDI": 255340036,
        "CAMBODIA": 255340037,
        "CAMEROON": 255340038,
        "CANADA": 255340039,
        "CAPE VERDE": 255340040,
        "CAYMAN ISLANDS": 255340041,
        "CENTRAL AFRICAN REPUBLIC": 255340042,
        "CHAD": 255340043,
        "CHILE": 255340044,
        "CHINA": 255340045,
        "CHRISTMAS ISLAND": 255340046,
        "COCOS KEELING ISLANDS": 255340047,
        "COLOMBIA": 255340048,
        "COMOROS": 255340049,
        "CONGO": 255340050,
        "COOK ISLANDS": 255340051,
        "COSTA RICA": 255340052,
        "COTE D'IVOIRE": 255340053,
        "CROATIA": 255340054,
        "CUBA": 255340055,
        "CYPRUS": 255340056,
        "CZECH REPUBLIC": 255340057,
        "DENMARK": 255340058,
        "DJIBOUTI": 255340059,
        "DOMINICA": 255340060,
        "DOMINICAN REPUBLIC": 255340061,
        "EAST TIMOR": 255340062,
        "ECUADOR": 255340063,
        "EGYPT": 255340064,
        "EL SALVADOR": 255340065,
        "EQUATORIAL GUINEA": 255340066,
        "ERITREA": 255340067,
        "ESTONIA": 255340068,
        "ETHIOPIA": 255340069,
        "FAROE ISLANDS": 255340070,
        "FIJI": 255340071,
        "FINLAND": 255340072,
        "FRANCE": 255340073,
        "FRENCH GUIANA": 255340074,
        "FRENCH POLYNESIA": 255340075,
        "FRENCH SOUTHERN TERRITORIES": 255340076,
        "GABON": 255340077,
        "GAMBIA": 255340078,
        "GEORGIA": 255340079,
        "GERMANY": 255340080,
        "GHANA": 255340081,
        "GIBRALTAR": 255340082,
        "GREECE": 255340083,
        "GREENLAND": 255340084,
        "GRENADA": 255340085,
        "GUADELOUPE": 255340086,
        "GUAM": 255340087,
        "GUATEMALA": 255340088,
        "GUINEA": 255340089,
        "GUINEA-BISSAU": 255340090,
        "GUYANA": 255340091,
        "HAITI": 255340092,
        "HEARD AND MCDONALD ISLANDS": 255340093,
        "HONDURAS": 255340094,
        "HONG KONG - SAR OF CHINA": 255340095,
        "HUNGARY": 255340096,
        "ICELAND": 255340097,
        "INDIA": 255340098,
        "INDONESIA": 255340099,
        "IRAN": 255340100,
        "IRAQ": 255340101,
        "IRELAND": 255340102,
        "ISRAEL": 255340103,
        "ITALY": 255340104,
        "JAMAICA": 255340105,
        "JAPAN": 255340106,
        "JORDAN": 255340107,
        "KAZAKHSTAN": 255340108,
        "KENYA": 255340109,
        "KIRIBATI": 255340110,
        "KUWAIT": 255340111,
        "KYRGYZSTAN": 255340112,
        "LAO": 255340113,
        "LATVIA": 255340114,
        "LEBANON": 255340115,
        "LESOTHO": 255340116,
        "LIBERIA": 255340117,
        "LIBYAN ARAB JAMAHIRIYA": 255340118,
        "LIECHTENSTEIN": 255340119,
        "LITHUANIA": 255340120,
        "LUXEMBOURG": 255340121,
        "MACAU - SAR OF CHINA": 255340122,
        "MACEDONIA": 255340123,
        "MADAGASCAR": 255340124,
        "MALAWI": 255340125,
        "MALAYSIA": 255340126,
        "MALDIVES": 255340127,
        "MALI": 255340128,
        "MALTA": 255340129,
        "MARSHALL ISLANDS": 255340130,
        "MARTINIQUE": 255340131,
        "MAURITANIA": 255340132,
        "MAURITIUS": 255340133,
        "MAYOTTE": 255340134,
        "METROPOLITAN FRANCE": 255340135,
        "MEXICO": 255340136,
        "MICRONESIA": 255340137,
        "MOLDOVA": 255340138,
        "MONACO": 255340139,
        "MONGOLIA": 255340140,
        "MONTSERRAT": 255340141,
        "MOROCCO": 255340142,
        "MOZAMBIQUE": 255340143,
        "MYANMAR": 255340144,
        "NAMIBIA": 255340145,
        "NAURU": 255340146,
        "NEPAL": 255340147,
        "NETHERLANDS": 255340148,
        "NETHERLANDS ANTILLES": 255340149,
        "NEW CALEDONIA": 255340150,
        "NEW ZEALAND": 255340151,
        "NICARAGUA": 255340152,
        "NIGER": 255340153,
        "NIGERIA": 255340154,
        "NIUE": 255340155,
        "NORFOLK ISLAND": 255340156,
        "NORTH KOREA": 255340157,
        "NORTHERN MARIANA ISLANDS": 255340158,
        "NORWAY": 255340159,
        "OMAN": 255340160,
        "PAKISTAN": 255340161,
        "PALAU": 255340162,
        "PANAMA": 255340163,
        "PAPUA NEW GUINEA": 255340164,
        "PARAGUAY": 255340165,
        "PERU": 255340166,
        "PHILIPPINES": 255340167,
        "PITCAIRN": 255340168,
        "POLAND": 255340169,
        "PORTUGAL": 255340170,
        "PUERTO RICO": 255340171,
        "QATAR": 255340172,
        "REUNION": 255340173,
        "ROMANIA": 255340174,
        "RUSSIA": 255340175,
        "RWANDA": 255340176,
        "SAINT KITTS AND NEVIS": 255340177,
        "SAINT LUCIA": 255340178,
        "SAINT VINCENT AND THE GRENADINES": 255340179,
        "SAMOA": 255340180,
        "SAN MARINO": 255340181,
        "SAO TOME AND PRINCIPE": 255340182,
        "SAUDI ARABIA": 255340183,
        "SENEGAL": 255340184,
        "SERBIA": 255340185,
        "SEYCHELLES": 255340186,
        "SIERRA LEONE": 255340187,
        "SINGAPORE": 255340188,
        "SLOVAKIA": 255340189,
        "SLOVENIA": 255340190,
        "SOLOMON ISLANDS": 255340191,
        "SOMALIA": 255340192,
        "SOUTH AFRICA": 255340193,
        "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS": 255340194,
        "SOUTH KOREA": 255340195,
        "SPAIN": 255340196,
        "SRI LANKA": 255340197,
        "ST HELENA": 255340198,
        "ST PIERRE AND MIQUELON": 255340199,
        "SUDAN": 255340200,
        "SURINAME": 255340201,
        "SVALBARD AND JAN MAYEN ISLANDS": 255340202,
        "SWAZILAND": 255340203,
        "SWEDEN": 255340204,
        "SWITZERLAND": 255340205,
        "SYRIAN ARAB REPUBLIC": 255340206,
        "TAIWAN": 255340207,
        "TAJIKISTAN": 255340208,
        "TANZANIA": 255340209,
        "THAILAND": 255340210,
        "THE DEMOCRATIC REPUBLIC OF CONGO": 255340211,
        "THE FALKLAND ISLANDS": 255340212,
        "TOGO": 255340213,
        "TOKELAU": 255340214,
        "TONGA": 255340215,
        "TRINIDAD AND TOBAGO": 255340216,
        "TUNISIA": 255340217,
        "TURKEY": 255340218,
        "TURKMENISTAN": 255340219,
        "TURKS AND CAICOS ISLANDS": 255340220,
        "TUVALU": 255340221,
        "UGANDA": 255340222,
        "UKRAINE": 255340223,
        "UNITED ARAB EMIRATES": 255340224,
        "UNITED STATES MINOR OUTLYING ISLANDS": 255340226,
        "URUGUAY": 255340227,
        "US VIRGIN ISLANDS": 255340228,
        "UZBEKISTAN": 255340229,
        "VANUATU": 255340230,
        "VATICAN CITY": 255340231,
        "VENEZUELA": 255340232,
        "VIET NAM": 255340233,
        "WALLIS AND FUTUNA ISLANDS": 255340234,
        "WESTERN SAHARA": 255340235,
        "YEMEN": 255340236,
        "ZAMBIA": 255340237,
        "ZIMBABWE": 255340238,
    }
  

  const survey = new Model(surveyJson);


    survey.onComplete.add((sender) => {

        const countryCode = countryMapping[sender.data.country.toUpperCase()] || null; // Default to null if country isn't found

    const surveyData = {
      title: sender.data.title,
      firstName: sender.data.firstName,
      lastName: sender.data.lastName,
      email: sender.data.email,
        dob: sender.data.dob,
        country: countryCode,
        query: sender.data.query,
      phone: sender.data.phone,
      marketingPreferences: sender.data.marketingPreferences,  // This is an array, handle accordingly in Logic App
      trackingId: trackingId,  // Add the tracking ID from the URL params
    };

    // Log the payload to inspect before sending to the Logic App
    console.log("Survey Data to send:", surveyData);

    fetch('https://prod-02.uksouth.logic.azure.com:443/workflows/fc3f999ccbbc473cb118b238bed0678b/triggers/When_Hospitality_Form_is_Submitted/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2FWhen_Hospitality_Form_is_Submitted%2Frun&sv=1.0&sig=QBnUmFLtYk4GdiFaCSsV2RvHXYiEoYX_fYP2giX1S0s', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(surveyData),  // Send the form data as JSON to the Logic App
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Form submitted successfully:", data);
        setIsSubmitted(true); // Set the submission state to true
      })
      .catch((error) => {
        console.error("Error submitting form:", error);
      });
  });

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100vw',
      height: '100vh',
      boxSizing: 'border-box',
    }}>
     
        <Survey model={survey} />
      
    </div>
  );
}

export default SurveyForm;
